import React, { useState } from "react";
import gaff from "./images/gaff.gif";
import github from "./images/github.png";
import gaffDemo from "./images/gaff_demo.gif";
import linkedin from "./images/linkedin.png";
import gptotd from "./images/gptotd.gif";
import gptotdDemo from "./images/gptotd_demo.gif";
import greet from "./images/greet.png";
import greetDemo from "./images/greetDemo.gif";
import analyseraBrfDemo from "./images/analyserabrf.gif";
import analyseraBrf from "./images/analyserabrf_icon.png";
import volta from "./images/volta.jpeg";
import voltaDemo from "./images/volta_demo.gif";
import dormrun from "./images/dormrun.png";
import dormrunDemo from "./images/dormrun_demo.gif";
import nolanz from "./images/nolanz.png";
import nolanzDemo from "./images/nolanz_demo.gif";
import homerun from "./images/homerun.png";
import homerunDemo from "./images/homerun_demo.gif";
import podtitles from "./images/podtitles.gif";
import podtitlesDemo from "./images/podtitles_demo.gif";
import Tooltip from "./components/Tooltip";

function App() {
  return (
    <div className="md:w-7/12 w-10/12 md:pt-40 pt-20 pb-20 mx-auto text-2xl text-gray-600 font-light">
      <p className="text-3xl font-medium">Hey, I'm Johan </p>

      <div className="gap-2 mt-6">
        <span>
          I'm currently building AI agents at Sana. I have a background in
          Computer Science and previous experience from management consulting,
          startups and scaleups at companies like BCG, Volta Greentech and
          Northvolt.{" "}
        </span>
      </div>

      <div className="gap-2 mt-6">
        <span>In my spare time I have always liked to build things:</span>

        <div className="grid md:grid-cols-9 grid-cols-4 mt-8 gap-4">
          <Tooltip
            demo={podtitlesDemo}
            emoji="💬"
            rotate={6}
            icon={podtitles}
            title="Podtitles"
            description="AI generated podcast subtitles"
            link="https://github.com/johan-akerman/SpotifyTranscripts"
          />

          <Tooltip
            demo={analyseraBrfDemo}
            emoji="🔍"
            rotate={-6}
            icon={analyseraBrf}
            title="AnalyseraBrf"
            description="AI real estate analysis"
            link="https://analyserabrf.se"
          />

          <Tooltip
            demo={greetDemo}
            emoji="👋"
            rotate={0}
            icon={greet}
            title="Greet"
            description="Get paid to refer friends"
            link="https://github.com/johan-akerman/Greet"
          />

          <Tooltip
            demo={homerunDemo}
            rotate={-6}
            emoji="🏠"
            icon={homerun}
            title="Homerun"
            description="Compare apartment prices"
            link="https://github.com/johan-akerman/Homerun"
          />

          <Tooltip
            demo={gaffDemo}
            rotate={6}
            icon={gaff}
            title="Gaff"
            emoji="🤙"
            description="Daily casual calls"
            link="https://apps.apple.com/us/app/gaff-talk-with-friends-daily/id1644599803"
          />

          <Tooltip
            demo={nolanzDemo}
            rotate={6}
            emoji="🎬"
            icon={nolanz}
            title="Nolan"
            description="Dribbble for AI videos"
            link="https://nolanz.ai/"
          />

          <Tooltip
            demo={voltaDemo}
            rotate={-3}
            icon={volta}
            emoji="🐄"
            title="Volta Greentech"
            description="Website for Volta"
            link="https://github.com/johan-akerman/VoltaGreentech"
          />

          <Tooltip
            demo={gptotdDemo}
            rotate={6}
            emoji="🏆"
            icon={gptotd}
            title="GPT of the day"
            description="Product Hunt for GPTs"
            link="https://github.com/johan-akerman/GPTOfTheDay"
          />

          <Tooltip
            demo={dormrunDemo}
            emoji="🚪"
            rotate={-6}
            icon={dormrun}
            title="Dormrun"
            description="Compare student housing"
            link="https://github.com/johan-akerman/Dormrun"
          />
        </div>
      </div>

      <p className="mt-10">
        Want to get in touch? Please reach out{" "}
        <a
          href="https://www.linkedin.com/in/johan-akerman/"
          target="_blank"
          className="inline-flex ml-1 align-middle mr-1"
        >
          <img
            src={linkedin}
            className="h-8 w-8 rounded-lg transform hover:rotate-0 transition duration-150"
          />
        </a>
        <a
          href="https://github.com/johan-akerman"
          target="_blank"
          className="inline-flex ml-1 align-middle"
        >
          <img
            src={github}
            className="h-8 w-8 rounded-lg transform hover:rotate-0 transition duration-150"
          />
        </a>
      </p>
    </div>
  );
}

export default App;
